var sourcebeauty;
(function($) {
  "use strict";
  sourcebeauty = (function() {
    return {
      init: function() {
        // Header
        this.announcement();
        this.fixedHeader();
        this.cart();
        this.cartProducts();
        this.account();
        this.search();
        this.mobileMenu();
        this.popupNewsletter();
        this.languages();

        // Home
        this.hero();
        this.homeProducts();
        this.topTrendingCategories();
        this.customerReviews();
        this.latestNews();
        this.press();
        this.instagram();
        this.homeBlocks();

        // Collection
        this.collection();
        this.collectionFilter();

        // Product
        this.productImages();
        this.productQuantity();
        this.recentlyViewed();
        this.productForm();
        this.productRightProducts();

        // Pages
        this.helpPages();
        this.contactPage();
        this.brandDirectory();
        this.wishlistPage();

        // Blog
        this.blog();
        this.articleProducts();

        // Utilites
        this.matchHeight();
        this.video();
        this.accordion();
        this.zoom();
        this.productGridItemVariants();
        this.aos();
        this.scrollbar();
        this.gallery();
        this.quiz();
        this.dateInputs();
      },

      // Header
      announcement: function() {
        var length = $(".js-announcement-item").length;
        var current = 1;
        if(length > 1) {
          setInterval(function () {
            var translate = current * 100;
            if(current < length) {
              current++;
              $(".js-announcement-item").css("transform", "translateY(-" + translate + "%)");
            } else {
              current = 1;
              $(".js-announcement-item").addClass("no-transition").addClass("no-transform");
              setTimeout(function () {
                $(".js-announcement-item").removeClass("no-transition").removeClass("no-transform").css("transform", "none");
              }, 1000);
            }
          }, 4000);
        }
      },

      fixedHeader: function() {
        $(".js-wrap-header").css("height", $(".js-wrap-header").outerHeight());
        $(".js-header").addClass("fixed-header");
      },

      cart: function() {

        $(".js-open-canvas-cart").on("click", function() {
                
          $(".js-canvas-cart").addClass("active");
          $("body").css("overflow", "hidden");
          return false;
        });
        
        $("body").on("click", ".js-close-canvas-cart", function() {
          $(".js-canvas-cart").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });
        $("body").on("click", ".js-delete-product-canvas", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = 0;
          $(".js-cart-content").addClass("is-loading-2");
           
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
                sourcebeauty.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              sourcebeauty.refreshCart();
            }
          });
       
          return false;
        });
        $("body").on("click", ".js-change-quantity", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = parseInt($(this).attr("data-quantity"));
          $(".js-cart-content").addClass("is-loading-2");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
                sourcebeauty.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              sourcebeauty.refreshCart();
            }
          });
          return false;
        });
      },

      cartProducts: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-cart-products").owlCarousel({
            rtl: true,
            loop: false,
            margin: 14,
            nav: true,
            items: 1,
            dots: false,
            autoplay: false
          });
        } else {
          $(".js-cart-products").owlCarousel({
            loop: false,
            margin: 14,
            nav: true,
            items: 1,
            dots: false,
            autoplay: false
          });
        }
      },

      account: function() {
        $("body").on("click", ".js-toggle-account", function () {
          $(this).toggleClass("active");
          $(".js-login").toggleClass("active");
          return false;
        });
        $("body").on("click", ".js-go-to-canvas-forgotten-password", function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").removeClass("d-none");
          return false;
        });
        $("body").on("click", ".js-back-to-login-canvas", function () {
          $(".js-login-canvas-login").removeClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").addClass("d-none")
          return false;
        });
        $("body").on("click", ".js-go-to-canvas-register", function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").removeClass("d-none")
          return false;
        });
        $("body").on("click", ".js-go-to-forgotten-password", function () {
          $(".js-login-login").addClass("d-none");
          $(".js-login-forgotten-password").removeClass("d-none");
          return false;
        });
        $("body").on("click", ".js-back-to-login", function () {
          $(".js-login-login").removeClass("d-none");
          $(".js-login-forgotten-password").addClass("d-none");
          return false;
        });
        $("body").on("click", ".js-open-account-left", function () {
          $(this).addClass("active");
        });
      },

      search: function() {
        $(".js-open-search").click(function () {
          $(".js-search").addClass("active");
          $(".js-close-search").addClass("active");
          setTimeout(function () {
            $(".js-search-input").focus();
          }, 300);
          return false;
        });
        $(".js-close-search").click(function () {
          $(".js-search").removeClass("active");
          $(".js-close-search").removeClass("active");
          return false;
        });
      },

      mobileMenu: function() {
        $(".js-open-mobile-menu").click(function () {
          if($(this).hasClass("active")) {
            $("body").css("overflow", "visible").removeClass("active-mobile-menu");
          } else {
            $("body").css("overflow", "hidden").addClass("active-mobile-menu");
          }
          $(".js-mobile-menu").toggleClass("active");
          $(this).toggleClass("active");
          var height = $(".js-mobile-menu").height();
          $(".js-match-mobile-menu-height").css("height", height);
          return false;
        });
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-carousel-mobile-menu").owlCarousel({
            rtl: true,
            loop: false,
            margin: 14,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false
          });
        } else {
          $(".js-carousel-mobile-menu").owlCarousel({
            loop: false,
            margin: 14,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false
          });
        }
        $(".js-go-to-mobile-submenu").click(function () {
          $(".js-carousel-mobile-menu").trigger('to.owl.carousel', 1);
          var index = $(this).attr("data-index");
          $(".js-mobile-menu-second-step").addClass("d-none");
          $(".js-mobile-menu-second-step[data-index='" + index + "']").removeClass("d-none");
          return false;
        });
        $(".js-go-to-mobile-first-menu").click(function () {
          $(".js-carousel-mobile-menu").trigger('to.owl.carousel', 0);
          return false;
        });
      },

      popupNewsletter: function() {
        if($(".js-popup-newsletter").length > 0) {
          if(localStorage.getItem('newsletter2') != 'true') {
            setTimeout(function () {
              $(".js-popup-newsletter").addClass("active");
            }, $(".js-popup-newsletter").attr("data-show-after"));
          } else {
            $(".js-popup-newsletter").hide();
          }

          $(".js-close-popup-newsletter").click(function () {
            localStorage.setItem('newsletter2', 'true');
            $(".js-popup-newsletter").removeClass("active");
            return false;
          });
        }
      },

        languages: function() {
          setInterval(function () {
            // Check the current Shopify locale
            if (window.Shopify.locale === 'en') {
              $(".js-exclude-translation").html('العربية');
            } else {
              $(".js-exclude-translation").html('English');
            }
          }, 500);
        
          $(".js-mobile-translation, .js-desktop-translation").click(function () {
            // Get the current locale
            var currentLocale = window.Shopify.locale;
        
            // Get the current URL path (without the domain)
            var currentPath = window.location.pathname;
            var newUrl = window.location.origin;  // This gives the base URL (e.g., https://www.sourcebeauty.com)
        
            // If the current language is English, switch to Arabic
            if (currentLocale === 'en') {
              if (!currentPath.startsWith('/ar')) {
                newUrl += '/ar' + currentPath; // Append '/ar' in front of the current path
              }
            } else {
              // If the current language is Arabic, switch to English
              if (currentPath.startsWith('/ar')) {
                newUrl += currentPath.replace('/ar', ''); // Remove '/ar' from the path
              }
            }
        
            // Redirect to the new URL
            window.location.href = newUrl;
        
            return false; // Prevent default action
          });
        },

      // Home
      hero: function() {

      },

      homeProducts: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-home-products").owlCarousel({
            rtl: true,
            loop: false,
            margin: 24,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              768: {
                items: 3,
                margin: 20
              },
              992: {
                items: 4
              },
              1200: {
                items: 5,
                margin: 24
              }
            }
          });
        } else {
          $(".js-home-products").owlCarousel({
            loop: false,
            margin: 24,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              768: {
                items: 3,
                margin: 20
              },
              992: {
                items: 4
              },
              1200: {
                items: 5,
                margin: 24
              }
            }
          });
        }
      },

      topTrendingCategories: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-top-categories-carousel").owlCarousel({
            rtl: true,
            loop: false,
            margin: 24,
            nav: false,
            items: 5,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 7
              },
              768: {
                items: 2,
                margin: 14
              },
              992: {
                items: 4,
                margin: 20
              },
              1200: {
                items: 5,
                margin: 24
              }
            }
          });
        } else {
          $(".js-top-categories-carousel").owlCarousel({
            loop: false,
            margin: 24,
            nav: false,
            items: 5,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 7
              },
              768: {
                items: 2,
                margin: 14
              },
              992: {
                items: 4,
                margin: 20
              },
              1200: {
                items: 5,
                margin: 24
              }
            }
          });
        }
      },

      customerReviews: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-customer-reviews-carousel").owlCarousel({
            rtl: true,
            loop: true,
            margin: 24,
            nav: true,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 24
              },
              992: {
                items: 2,
                margin: 24
              }
            }
          });
        } else {
          $(".js-customer-reviews-carousel").owlCarousel({
            loop: true,
            margin: 24,
            nav: true,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 24
              },
              992: {
                items: 2,
                margin: 24
              }
            }
          });
        }
      },

      latestNews: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-carousel-latest-news").owlCarousel({
            rtl: true,
            loop: false,
            margin: 24,
            nav: false,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 24
              },
              768: {
                items: 2,
                margin: 24
              },
              992: {
                items: 3
              }
            }
          });
        } else {
          $(".js-carousel-latest-news").owlCarousel({
            loop: false,
            margin: 24,
            nav: false,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 24
              },
              768: {
                items: 2,
                margin: 24
              },
              992: {
                items: 3
              }
            }
          });
        }
      },

      press: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-press-carousel").owlCarousel({
            rtl: true,
            loop: false,
            margin: 22,
            nav: false,
            items: 1,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                autoHeight: true,
                loop: true
              },
              992:{
                autoHeight: false,
                loop: false
              }
            }
          });  
        } else {
          $(".js-press-carousel").owlCarousel({
            loop: false,
            margin: 22,
            nav: false,
            items: 1,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                autoHeight: true,
                loop: true
              },
              992:{
                autoHeight: false,
                loop: false
              }
            }
          });  
        }
        $(".js-press-logo").hover(function () {
          var index = $(this).attr("data-index") - 1;
          $(".js-press-carousel").trigger('to.owl.carousel', index);
          $(".js-press-carousel").trigger('stop.owl.autoplay');    
        });
        $(".js-press-carousel").on('changed.owl.carousel', function(event) {
          var index = event.item.index + 1;
          $(".js-press-logo").removeClass("active");
          $(".js-press-logo[data-index='" + index + "']").addClass("active");
        });
        $(".js-press-carousel").trigger('to.owl.carousel', 2);
        $(".js-press-carousel").trigger('stop.owl.autoplay');
      },

      instagram: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-instagram-feed-carousel").owlCarousel({
            rtl: true,
            loop: true,
            margin: 22,
            nav: false,
            items: 7,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                items: 4,
                margin: 12
              },
              992: {
                items: 5,
                margin: 22
              },
              1099: {
                items: 6
              },
              1199:{
                items: 7
              }
            }
          });
        } else {
          $(".js-instagram-feed-carousel").owlCarousel({
            loop: true,
            margin: 22,
            nav: false,
            items: 7,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                items: 4,
                margin: 12
              },
              992: {
                items: 5,
                margin: 22
              },
              1099: {
                items: 6
              },
              1199:{
                items: 7
              }
            }
          });
        }
      },

      homeBlocks: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-home-blocks-slider").owlCarousel({
            rtl: true,
            loop: true,
            margin: 9,
            nav: true,
            items: 3,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                items: 1,
                margin: 8
              },
              768: {
                items: 2,
                margin: 9
              },
              992: {
                items: 3
              },
              1600: {
                items: 4
              }
            }
          });
        } else {
          $(".js-home-blocks-slider").owlCarousel({
            loop: true,
            margin: 9,
            nav: true,
            items: 3,
            dots: false,
            autoplay: true,
            responsive: {
              0:{
                items: 1,
                margin: 8
              },
              768: {
                items: 2,
                margin: 9
              },
              992: {
                items: 4
              },
              1600: {
                items: 4
              }
            }
          });
        }
      },

      // Collection
      collection: function() {
        $("body").on("click", ".js-collection-next-page", function () {
          var href = $(this).attr("href");
          $(".js-collection-action").remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
            sourcebeauty.productGridItemVariants();
            sourcebeauty.matchHeight();
            setTimeout(function () {
              sourcebeauty.matchHeight();
            }, 1000);
          });
          return false;
        });
      },

      collectionFilter: function() {
        $(".js-toggle-filter-widget").click(function() {
          $(this).parent().parent().find(".js-filter-widget").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          // $(this).parent().parent().find(".js-filter-widget:not(.current).active .js-filter-widget-content").slideToggle(500);
          // $(this).parent().parent().find(".js-filter-widget:not(.current).active").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").slideToggle(500);
        });

        $(".js-filter-widget.active").each(function () {
          $(this).find(".js-filter-widget-content").slideToggle(500);
        });
        
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-sort-by").attr("data-value");
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if($(".js-collection-items").hasClass("search2")) {
            return $(".js-collection-items").attr("data-url") + "&sort_by=" + Shopify.queryParams.sort_by;
          } else {
            if(Shopify.queryParams.constraint == '') {
              return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
            } else {
              return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
            }
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection").addClass("loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection").html($(result).find(".js-collection").html());
              sourcebeauty.productGridItemVariants();
              sourcebeauty.matchHeight();
              setTimeout(function () {
                sourcebeauty.matchHeight();
              }, 1000);
              $(".js-collection").removeClass("loading");
            },
            error: function() {
              $(".js-collection").removeClass("loading");
            }
          })
        }

        $("body").on("click", ".js-open-sort-by", function(y) {
          $(".js-sort-by-dropdown, .js-open-sort-by").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-change-sort-by", function(y) {
          Shopify.queryParams.sort_by = $(this).attr("data-value");
          filterGetContent(filterCreateUrl());
          $(".js-sort-by").html($(this).html());
          $(".js-sort-by-dropdown, .js-open-sort-by").removeClass("active");
          return false;
        });

        $("body").on("change", ".js-change-mobile-sort-by", function(y) {
          $(".js-change-sort-by[data-index='" + $(this).val() + "']").click();
        });

        $("input.tag").change(function () {
          var tags = [];
          if($(this).is(":checked")) {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
            $(this).prop("checked", true);
          } else {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
          }
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("click", ".js-open-mobile-filter", function () {
          $(".js-filter").addClass("active");
          $("body").css("overflow", "hidden")
        });

        $("body").on("click", ".js-close-mobile-filter", function () {
          $(".js-filter").removeClass("active");
          $("body").css("overflow", "visible")
        });
      },

      // Product
      productImages: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-mobile-product-images").owlCarousel({
            rtl: true,
            loop: false,
            margin: 9,
            nav: false,
            dots: true,
            items: 1
          });
        } else {
          $(".js-mobile-product-images").owlCarousel({
            loop: false,
            margin: 9,
            nav: false,
            dots: true,
            items: 1
          });
        }
        $(".js-product-thumbnails-carousel").slick({
          slidesToShow: 8,
          slidesToScroll: 8,
          arrows: true,
          dots: false,
          vertical: true,
          verticalSwiping: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7
              }
            },
            {
              breakpoint: 1298,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 6
              }
            },
            {
              breakpoint: 1098,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            }
          ]
        });
        $("body").on("click", ".js-product-thumbnail-image", function () {
          $(".js-product-thumbnail-image").removeClass("active");
          $(this).addClass("active");
          $(".js-product-image").removeClass("active");
          $(".js-product-image[data-id='" + $(this).attr("data-id") + "']").addClass("active");
          return false;
        });
      },

      productQuantity: function() {
        $(".js-quantity-up").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find("input").val(q_val_up+1).keyup(); 
          return false;
        });
        
        $(".js-quantity-down").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 1) {
            $(this).parent().find("input").val(q_val_up-1).keyup(); 
          }
          return false;
        });
      },

      recentlyViewed: function() {
        Shopify.Products.showRecentlyViewed( { howManyToShow: 12 } );
        setTimeout(function () {
          if($(".recently-viewed-product").length > 0) {
            $(".js-no-recently-viewed").hide();
            $(".js-recently-viewed-carousel").removeClass("d-none");
            if($("html[lang='ar'], html[lang='ar']").length > 0) {
              $(".js-recently-viewed-carousel").owlCarousel({
                rtl: true,
                loop: false,
                margin: 24,
                nav: true,
                items: 4,
                dots: false,
                autoplay: false,
                responsive: {
                  0:{
                    items: 2,
                    margin: 10
                  },
                  768: {
                    items: 3,
                    margin: 20
                  },
                  992: {
                    items: 4
                  },
                  1200: {
                    items: 5,
                    margin: 24
                  }
                }
              });
            } else {
              $(".js-recently-viewed-carousel").owlCarousel({
                loop: false,
                margin: 24,
                nav: true,
                items: 4,
                dots: false,
                autoplay: false,
                responsive: {
                  0:{
                    items: 2,
                    margin: 10
                  },
                  768: {
                    items: 3,
                    margin: 20
                  },
                  992: {
                    items: 4
                  },
                  1200: {
                    items: 5,
                    margin: 24
                  }
                }
              });
            }
            sourcebeauty.matchHeight();
          } else {
            $(".js-no-recently-viewed").show();
          }
        }, 2500);
        setInterval(function () {
          $(".js-recently-viewed-product").each(function () {
            if(!$(this).hasClass("active")) {
              var handle = $(this).attr("data-product-handle");
              var that = $(this);
              jQuery.getJSON('/products/' + handle + '.js', function (product) {
                that.find(".js-recently-product-image").attr("src", product.featured_image);
                that.addClass("active");
                var brand = product.vendor;
                var tag = '';
                var i;
                for (i = 0; i < product.tags.length; ++i) {
                  if(product.tags[i].indexOf('__tag=') != -1) {
                    tag = product.tags[i].replace('__tag=', '');
                  }
                }
                if(brand != '') {
                  $(that).find(".js-product-grid-item-brand").html('<div class="product-grid-item__brand">' + brand + '</div>');
                }
                if(tag != '') {
                  $(that).find(".js-product-grid-item-tag").html('<div class="product-grid-item__tag">' + tag + '</div>');
                }
              }); 
            }
          }); 
        }, 550);
      },

      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
              if (variant.available) {
                $(that).find(".js-product-add-to-cart").removeClass("d-none");
                $(that).find(".js-product-out-of-stock").addClass("d-none");
              } else {
                $(that).find(".js-product-add-to-cart").addClass("d-none");
                $(that).find(".js-product-out-of-stock").removeClass("d-none");
              }
              if(variant.compare_at_price > variant.price) {
                $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price));
              } else {
                $(that).find(".js-price-old").addClass("d-none")
                $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price));
              }
              if(variant.featured_image !== null) {
                var position = variant.featured_image.position;
                $(".js-mobile-product-images").trigger('to.owl.carousel', position - 1);
                $(".js-product-thumbnail-image[data-id='" + position + "']").click();
              } 
            } else {
              $(that).find(".js-product-add-to-cart").addClass("d-none");
              $(that).find(".js-product-out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        $(".js-product").each(function () {
          variants($(this).attr("data-product-id"));
        });

        $(".js-product-color").click(function () {
          $(this).parent().parent().find("li").removeClass("active");
          $(this).parent().addClass("active");
          $(this).closest(".js-product-colors").find(".js-product-color p").removeClass("active");
          $(this).find("p").addClass("active");
          var option = $(this).parent().parent().attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          $(".js-sticky-product-color p").removeClass("active");
          $(".js-sticky-product-color").parent().removeClass("active");
          $(".js-sticky-product-color[data-value='" + value + "'] p").addClass("active");
          $(".js-sticky-product-color[data-value='" + value + "']").parent().addClass("active");
          return false;
        });


        $("body").on("click", ".js-add-to-cart", function () {
          $(this).addClass("is-loading");

          $(".js-cart-content").addClass("is-loading-2");
          if($(this).hasClass("variant")) {
            var quantity = 1;
            var id = $(this).attr("data-variant-id");
            var properties = {};
          } else {
            var productId = $(this).attr("data-product-id");
            var quantity = $(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val();
            if(isNaN(quantity)) { quantity = 1; }
            var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
            var properties = {};
            $(".js-product[data-product-id='" + productId + "'] input[type='text'], .js-product[data-product-id='" + productId + "'] select, .js-product[data-product-id='" + productId + "'] textarea").each(function () {
              var getName = $(this).attr("name");
              if(typeof getName !== 'undefined') {
                if(getName.indexOf("properties") >= 0) {
                  var name = $(this).attr("name").replace("properties[", "").replace("]", "");
                  var value = $(this).val();
                  properties[name] = value;
                }
              }
            });
            $(".js-product[data-product-id='" + productId + "'] input[type='radio']").each(function () {
              var getName = $(this).attr("name");
              if(typeof getName !== 'undefined') {
                if(getName.indexOf("properties") >= 0) {
                  if($(this).is(":checked")) {
                    var name = $(this).attr("name").replace("properties[", "").replace("]", "");
                    var value = $(this).val();
                    properties[name] = value;
                  }
                }
              }
            });
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function() {
                sourcebeauty.refreshCart();
                 Rebuy.SmartCart.show();
              setTimeout(() => {
                Rebuy.Cart.fetchCart();
              }, 300);
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              sourcebeauty.refreshCart();
            }
          });
            
          return false;
        });

      $("body").on("click", ".js-add-to-cart-grid", function () {
          $(".js-cart-content").addClass("is-loading-2");
          $(this).addClass("is-loading");
          var quantity = 1;
          if ($(this).hasClass("variant")) {
            var id = $(this).attr("data-variant-id");
          } else {
            var id = $(this)
              .closest(".js-product-grid-item")
              .find("select[name='id']")
              .val();
          }
          var properties = {};
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: { id: id, quantity: quantity, properties: properties },
            success: function () {
              sourcebeauty.refreshCart();
              Rebuy.SmartCart.show();
              setTimeout(() => {
                Rebuy.Cart.fetchCart();
              }, 300);
            },
            error: function (response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              sourcebeauty.refreshCart();
            },
          });
          return false;
        });

        $("body").on("click", ".js-product-out-of-stock a", function () {
          $(".bis-reset")[0].click();
          return false;
        });
      },

      productRightProducts: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-product-right-products").owlCarousel({
            rtl: true,
            loop: false,
            margin: 19,
            nav: true,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 19
              },
              768: {
                items: 2,
                margin: 19
              },
              992: {
                items: 2
              }
            }
          });
        } else {
          $(".js-product-right-products").owlCarousel({
            loop: false,
            margin: 19,
            nav: true,
            items: 2,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 1,
                margin: 19
              },
              768: {
                items: 2,
                margin: 19
              },
              992: {
                items: 2
              }
            }
          });
        }
      },

      // Pages
      helpPages: function() {
        $(".js-help-menu").click(function () {
          $(this).addClass("active");
        });
      },

      contactPage: function() {
        $(".js-contact-form form").submit(function () {
          var content = $(".js-contact-body").val();
          content = "Order number: " + $(".js-contact-order-number").val() + "\nThis query is about: " + $(".js-contact-about").val() + "\n\n" + content;
          $(".js-contact-body").val(content);
        });
      },

      brandDirectory: function() {
        $(".js-go-to-brands").each(function () {
          if($(".js-brands-group[data-group='" + $(this).attr("data-id") + "']").length < 1) {
            $(this).addClass("unactive");
          }
        });
        $(".js-go-to-brands").click(function () {
          var id = $(this).attr("data-id");
          if($(".js-brands-group[data-group='" + $(this).attr("data-id") + "']").length > 0) {
            $('html, body').scrollTop($(".js-brands-group[data-group='" + $(this).attr("data-id") + "']").offset().top - 150);
          }
          return false;
        });
        if($(".js-wrap-brands-sticky-list").length > 0) {
          $(".js-brands-sticky-list").height($(".js-brands-sticky-list").outerHeight());
          $(".js-brands-sticky-list").width($(".js-brands-sticky-list").outerWidth());
          $(".js-brands-sticky-list").css("top", $(".js-header").outerHeight());
          $(window).scroll(function() {
            if($(window).scrollTop() > $(".js-wrap-brands-sticky-list").offset().top - $(".js-header").outerHeight()) {
              $(".js-brands-sticky-list").addClass("active");
            } else {
              $(".js-brands-sticky-list").removeClass("active");
            }
          });
        }
      },

      wishlistPage: function() {
        if($(".js-wishlist-login").length > 0) {
          $(document).on('submit','#customer_login', function() {
            localStorage.setItem('wishlist', 'true');
          });
        }
        if($(".shopify-challenge__container").length == 0) {
          if(localStorage.getItem('wishlist') == 'true') {
            localStorage.setItem('wishlist', 'false');
            window.location.href = '/pages/wishlist';
          }
        }
      },

      // Blog
      blog: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(this).parent().remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
        $(".js-open-blog-filter").click(function () {
          $(".js-blog-filter").addClass("active");
          return false;
        });
        $(".js-close-blog-filter").click(function () {
          $(".js-blog-filter").removeClass("active");
          return false;
        });
      },

      articleProducts: function() {
        if($("html[lang='ar'], html[lang='ar']").length > 0) {
          $(".js-article-products-carousel").owlCarousel({
            rtl: true,
            loop: false,
            margin: 36,
            nav: true,
            dots: false,
            items: 3,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              768: {
                margin: 24,
                items: 2
              },
              992: {
                items: 3,
                margin: 36
              }
            }
          });
        } else {
          $(".js-article-products-carousel").owlCarousel({
            loop: false,
            margin: 36,
            nav: true,
            dots: false,
            items: 3,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              768: {
                margin: 24,
                items: 2
              },
              992: {
                items: 3,
                margin: 36
              }
            }
          });
        }
      },

      // Utilities
      matchHeight: function() {
        $('.js-match-height').matchHeight();
        $('.js-match-height-1').matchHeight();
        $('.js-match-height-2').matchHeight();
        $('.js-match-height-3').matchHeight();
      },

      video: function() {
        $('.js-youtube-video').youtube_background();
        $('.js-vimeo-video').vimeo_player();
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
      },

      accordion: function() {
        $(".js-accordion-title").click(function() {
          $(this).parent().parent().find(".js-accordion").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
          $(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
          $(this).parent().find(".js-accordion-content").slideToggle(500);
        });
        $(".js-accordion.active").each(function () {
          $(this).find(".js-accordion-content").slideToggle(500);
        });
      },

      zoom: function() {
        $(".js-zoomit").each(function () {
          $(this).zoomIt();
        });
      },

      productGridItemVariants: function() {
        $(".js-product-grid-item").each(function () {
          if(!$(this).hasClass("initialized")) {
            $(this).addClass("initialized");
            var that = $(this);
            var productId = $(this).attr("data-product-id");
            var forloopIndex = $(this).attr("data-forloop-index");
            var collectionHandle = $(this).attr("data-collection-handle");
            var data = JSON.parse(document.getElementById('ProductJson' + productId + "-" + forloopIndex + "-" + collectionHandle).innerHTML);
            var selectCallback = function(variant, selector) {
              if (variant) {
                if (variant.available) {
                  $(that).find(".js-product-grid-item-in-stock").removeClass("d-none");
                  $(that).find(".js-product-grid-item-out-of-stock").addClass("d-none");
                } else {
                  $(that).find(".js-product-grid-item-in-stock").addClass("d-none");
                  $(that).find(".js-product-grid-item-out-of-stock").removeClass("d-none");
                }
                if(variant.compare_at_price > variant.price) {
                  $(that).find(".js-product-grid-item-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                  $(that).find(".js-product-grid-item-price-new").html(Shopify.formatMoney(variant.price));
                  $(that).find(".js-product-grid-item-price-new").addClass("price-new");
                } else {
                  $(that).find(".js-product-grid-item-price-old").addClass("d-none")
                  $(that).find(".js-product-grid-item-price-new").html(Shopify.formatMoney(variant.price));
                  $(that).find(".js-product-grid-item-price-new").removeClass("price-new");
                }
                if(variant.featured_image !== null) {
                  $(that).find(".js-product-grid-image").attr("src", variant.featured_image.src).attr("srcset", variant.featured_image.src).attr("data-srcset", variant.featured_image.src);
                } else {
                  $(that).find(".js-product-grid-image").attr("src", $(that).find(".js-product-grid-image").attr("data-default-image")).attr("srcset", $(that).find(".js-product-grid-image").attr("data-default-image")).attr("data-srcset", $(that).find(".js-product-grid-image").attr("data-default-image"));
                }
              } else {
                $(that).find(".js-product-grid-item-in-stock").addClass("d-none");
                $(that).find(".js-product-grid-item-out-of-stock").removeClass("d-none");
              }
            }
            new Shopify.OptionSelectors("product-select-" + productId + "-" + forloopIndex + "-" + collectionHandle, { product: data , onVariantSelected: selectCallback });
          }
        });
        $(".js-color-value").click(function () {
          $(this).closest(".js-color").find(".js-color-value p").removeClass("active");
          $(this).find("p").addClass("active");
          var option = $(this).closest(".js-color").attr("data-option");
          var value = $(this).closest(".js-color-value").attr("data-value");
          $(this).closest(".js-product-grid-item").find("select[data-option='" + option + "']").val(value).change();
          return false;
        });
        $(".js-open-all-colors a").click(function () {
          $(this).parent().addClass("d-none");
          $(this).closest(".js-color").removeClass("unactive");
          sourcebeauty.matchHeight();
          return false;
        });
      },

      aos: function() {
        AOS.init();
        setInterval(function () {
          $(".aos-init.aos-animate").addClass("animation-done");
        }, 300);
      },

      refreshCart: function() {
        $('#cart-content').load('/cart #cart-content', function() {
          $.getScript("https://easydonation.zestardshop.com/js/donation.js");
          $(".js-add-to-cart, .js-add-to-cart-grid").removeClass("is-loading");
          $(".js-cart-content").removeClass("is-loading");
          $(".js-cart-content").removeClass("is-loading-2");
          if($(window).outerWidth() > 767) {
            $(".js-canvas-cart").addClass("active");
            $("body").css("overflow", "hidden");
          }
          sourcebeauty.cartProducts();
          sourcebeauty.productGridItemVariants();
          sourcebeauty.matchHeight();
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-count').html(cart.item_count).attr("data-count", cart.item_count);
        });
      },

      scrollbar: function() {
        $('.js-scrollbar').scrollbar();
      },

      gallery: function() {
        $(".js-popup-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
        $(".js-mobile-popup-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
      },

      quiz: function() {
        setInterval(function () {
          if($("div[data-element='oct-quiz-resultWrapper oct-quiz-media']").length > 0) {
            $(".js-body").addClass("quiz-results");
          }
        }, 100);
      },

      dateInputs: function() {
        $(".js-input-date").datepicker({
          dateFormat: 'dd/mm/yy',
		  changeMonth: true,
          changeYear: true,
		  yearRange: '1930:-13',
		  maxDate: '-13y'

        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  sourcebeauty.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      sourcebeauty.init();
    }).on('shopify:section:unload', function() {
      sourcebeauty.init();
    }).on('shopify:section:select', function() {
      sourcebeauty.init();
    }).on('shopify:section:deselect', function() {
      sourcebeauty.init();
    }).on('shopify:block:select', function() {
      sourcebeauty.init();
    }).on('shopify:block:deselect', function() {
      sourcebeauty.init();
    });
}
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree to the terms and conditions of sales at checkout");
        return false;
      }
    });
  });




